import request from './request'

// const urlPath = 'http://asttest.eweiqi.com/aisitong/pcservice'
const urlPath = 'http://www.aistonego.com/aisitong/pcservice'

// 前台banner
export const GetAdvertisingPages = (params) => {
  return request({
    url: `${urlPath}/api/Advertising/GetAdvertisingPages`,
    method: "get",
    params
  })
}

// 前台获取上课瞬间
export const GetClassMoment = (params) => {
  return request({
    url: `${urlPath}/api/Reception/GetClassMoment`,
    method: "get",
    params
  })
}

// 前台获取获取文章精彩推荐
export const GetArticleRecommend = (params) => {
  return request({
    url: `${urlPath}/api/Reception/GetArticleRecommend`,
    method: "get",
    params
  })
}

// 前台获取获取最新动态,每个模块拿5个
export const GetLastDynamic = (params) => {
  return request({
    url: `${urlPath}/api/Reception/GetLastDynamic`,
    method: "get",
    params
  })
}

// 分页获取文章表页查询接口 （关键字搜索）
export const GetArticlePage = (params) => {
  return request({
    url: `${urlPath}/api/Reception/GetArticlePage`,
    method: "get",
    params
  })
}

// 获取文章详情
export const GetArticleDetails = (params) => {
  return request({
    url: `${urlPath}/api/Reception/GetArticleDetails`,
    method: "get",
    params
  })
}

// 教师号登录
export const TeacherLogin = (data) => {
  return request({
      url:`${urlPath}/api/CA/TeacherLogin`,
      method: "post",
      data
  })
}

// 分页获取课堂产品
export const GetReceptionClassroomPage = (params) => {
  return request({
    url: `${urlPath}/api/Reception/GetReceptionClassroomPage`,
    method: "get",
    params
  })
}

// 分页获取课堂菜单
export const GetClassroomTypes = (params) => {
  return request({
    url: `${urlPath}/api/Reception/GetClassroomTypes`,
    method: "get",
    params
  })
}

// 获取课堂产品分页文件数据
export const GetClassroomFiles = (params) => {
  return request({
    url: `${urlPath}/api/Reception/GetClassroomFiles`,
    method: "get",
    params
  })
}

// 文件获取
export const GetFileById = (params) => {
  return request({
    url: `${urlPath}/api/Files/GetFileById`,
    method: "get",
    params,
    responseType: 'blob'
  })
}

// 地图
export const GetCampusToJoins = (params) => {
  return request({
    url: `${urlPath}/api/CampusToJoin/GetCampusToJoins`,
    method: "get",
    params
  })
}
